/**
 * © 2021 Tandem Diabetes Care, Inc. All rights reserved.
 * Confidential Information of Tandem Diabetes Care, Inc.
 * Internal Use Only
 */
try {
	// RSPACK DefinePlugin sets VERSION
	window.VERSION = VERSION;
} catch {
	window.VERSION = '';
}

import('./bootstrap');
